import React, { useState } from "react";

const NotesContent = ({ onChange }) => {
  const [notesContent, setNotesContent] = useState("");

  const handleChange = (notesData) => {
    setNotesContent(notesData);
    onChange(notesData);
  };

  return (
    <div>
      <div class="bg-white border border-slate-200 grid grid-cols-6 gap-2 rounded-xl p-2 text-sm">
        <h1 class="text-center text-slate-300 text-xl font-bold col-span-6">
          Notes Content
        </h1>
        <textarea
          value={notesContent || ""}
          onChange={(e) => handleChange(e.target.value)}
          placeholder="Your Notes..."
          class="bg-slate-100 text-slate-600 h-28 placeholder:text-slate-600 placeholder:opacity-50 border border-slate-200 col-span-6 resize-none outline-none rounded-lg p-2 duration-300 focus:border-slate-600"
        ></textarea>
      </div>
    </div>
  );
};

export default NotesContent;
